import { observer } from 'mobx-react'

import CellContent from '../CellContent'
import { ContractActions } from '../constants'
import type { ImportedContract } from '../types'

interface Props {
  contract: ImportedContract
  index: number
  attribute: string
}

interface InvalidValue {
  value: unknown
}

function isInvalidValue(obj: unknown): obj is InvalidValue {
  return typeof obj === 'object' && obj !== null && 'value' in obj
}

const CustomFieldCellContent = ({ contract, index, attribute }: Props) => {
  const errored = contract.status === 'errored'
  const ready = contract.status === 'ready'
  const attributeValue = contract.custom_fields[index] ?? ''
  const value = isInvalidValue(attributeValue) ? attributeValue.value : attributeValue
  const printableValue = value ? String(value) : ''
  const message = contract.custom_fields_errors[index] ?? ''
  const ok = ready || !message
  const updated = contract.modified_keys.updated.includes(attribute)
  const removed = contract.modified_keys.removed.includes(attribute)
  const modified = contract.type != ContractActions.new && (updated || removed)

  return (
    <CellContent
      value={printableValue}
      message={message}
      modified={modified}
      errored={errored}
      ok={ok}
    />
  )
}

export default observer(CustomFieldCellContent)
